import React from 'react';
import './Stack.css';

const techCategories = [
  {
    group: 'Languages',
    items: 'Java · Kotlin\nRust · C++\nTypeScript\nPython · Scala\nGo · Elixir'
  },
  {
    group: 'Data & messaging',
    items: 'Kafka · Pulsar\nPostgres · Cassandra\nkdb+ · ClickHouse\nRedis · DuckDB\nIceberg · Arrow'
  },
  {
    group: 'Cloud & runtime',
    items: 'AWS · GCP · Azure\nKubernetes\nTerraform · Pulumi\nNomad · Consul\nBare metal · co-lo'
  },
  {
    group: 'Domain & protocol',
    items: 'FIX 4.x · 5.0 SP2\nISO 20022 · SWIFT\nFpML · FIXatdl\nOFX · CAMT/PAIN\nSolana · EVM'
  }
];

export default function Stack() {
  return (
    <section className="section shell" id="stack">
      <div className="cases-head" style={{ alignItems: 'center' }}>
        <div>
          <div className="section-label reveal">04 — Stack & expertise</div>
          <h2 className="display cases-head__title reveal" style={{ marginTop: '32px' }}>
            The toolkit<br /><em style={{ color: 'rgba(244, 241, 234, 0.5)' }}>we ship with.</em>
          </h2>
        </div>
        <p className="cases-head__sub reveal" style={{ color: 'rgba(244, 241, 234, 0.65)', textAlign: 'center' }}>
          We are language-pragmatic. The choices below reflect what is currently running in production for our clients. We add to the list when the problem demands it.
        </p>
      </div>

      <div className="tech-grid">
        {techCategories.map((tech, idx) => (
          <div key={idx} className="tech reveal">
            <div className="tech__head">
              <span className="tech__group">{tech.group}</span>
              <span className="tech__count">/{String(idx + 1).padStart(2, '0')}</span>
            </div>
            <div className="tech__items">
              {tech.items.split('\n').map((line, i) => (
                <div key={i}>{line}</div>
              ))}
            </div>
          </div>
        ))}
      </div>
    </section>
  );
}
